/**
 * Logo Map
 *
 * Maps kebab-case logo names to their component implementations.
 */

import * as Logos from "./logos";
import type { LogoComponent } from "./create-logo";
import type { LogoName } from "./types";

/**
 * Map of kebab-case logo names to their component implementations
 */
export const logoMap: Record<LogoName, LogoComponent> = {
  "va-waterfront": Logos.VaWaterfront,
};

/**
 * List of all available logo names for documentation and validation
 */
export const availableLogos = Object.keys(logoMap) as LogoName[];
